export default __webpack_public_path__ + "static/media/chevron-down.c9b61d83.svg";